import React, { useEffect } from "react";
// import Header from './../components/Header';
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Container, Col, Row, FormGroup, Label, Input } from "reactstrap";
import { getAmc } from "./../stores/services/amc.service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import {
  getFundByAmc,
  UpdateNavOfAllFunds,
  addDailyNav,
  getDailyNavOfAllFunds,
  getDeleteFundNav,
} from "./../stores/services/funds.service";
import { getNavDataForCalculation } from "./../stores/services/nav.service";
import { AiFillPlusCircle } from "react-icons/ai";
import { BsTable } from "react-icons/bs";
import moment from "moment";
import { convertToObject } from "typescript";
import {
  getChartOfAccounts,
  getLedgerInfoByCode,
} from "./../stores/services/chatofaccounts.service";
import {
  calculateLedgerTotals,
  getLedgerAccounts,
  getLedgerInfoByLedgerCode,
  numberWithCommas,
} from "../utils/customFunction";
import { useSelector } from "react-redux";
import { inWords } from "../stores/services/template.service";
import NumberFormat from "react-number-format";

const NavComponent = () => {
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);

  let date = new Date();
  const fund_code = JSON.parse(sessionStorage.getItem("fund_code") || "[]");
  const email = sessionStorage.getItem("email") || "";
  const amcCode = sessionStorage.getItem("amc_code") || "";
  const [Loading, setLoading] = useState(false);
  const [checkedField, setCheckedField] = useState<any>([]);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [showModalNav, setShowModalNav] = useState(false);
  const [calculatedLedgersData, setCalculatedLedgersData] = useState<any>([]);
  const [calculatedNetAsset, setCalculatedNetAsset] = useState(0);
  const [accFundLoading, setAccFundLoading] = useState<boolean>(false);
  const [NAVdate, setNAVDate] = useState(moment(date).format("YYYY-MM-DD"));
  const [allDailyNav, setAllDailyNav] = useState<any>([]);
  const [funds, setFunds] = useState<any>([]);
  let [fundFees, setFundFees] = useState<any>({});
  let [navDataForCalculation, setNavDataForCalculation] = useState<any>({});
  let [finalData, setFinalData] = useState<any>([]);
  let [trusteeFeeLedger, setTrusteeFeeLedger] = useState<any>([]);

  const [feeLedgers, setFeeLedgers] = useState([]);

  const [ledgers, setLedgers] = useState<any>([
    401010101, 301020101, 401010102, 30102010101, 401010201, 301020201,
    401010202, 301020202, 401010501, 301020501,
  ]);

  const [code, setCode] = useState("");
  const [previousNavModal, setPreviousNavModal] = useState(false);
  const [previousNavData, setPreviousNavData] = useState<any>([]);
  const [deleteNavModal, setDeleteNavModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<any>(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  React.useEffect(() => {
    const fetchFunds = async () => {
      try {
        const response = await getFundByAmc(
          email,
          amcCode,
          fund_code?.length > 0 ? fund_code : "",
        );
        setFunds(response.data.data);
      } catch (error) {}
    };
    fetchFunds();
  }, []);

  const getDailyNav = async () => {
    setLoading(true);
    setAccFundLoading(true);
    allDailyNav.length = 0;
    setAllDailyNav(allDailyNav);
    try {
      const response = await getDailyNavOfAllFunds(email, amcCode, NAVdate);
      const dailyNavData: any = Object.values(response?.data || {});
      let tempArr = dailyNavData?.map((ele) => {
        return {
          ...ele,
          checked: false,
        };
      });
      setCheckedField(tempArr);
      setAllDailyNav(tempArr);
      // let fooArray = Object.entries(response.data);
      // fooArray.forEach(([key, value]) => {
      //   allDailyNav.push(value);
      // });
      setAccFundLoading(false);
      setLoading(false);
    } catch (error) {}
    setAccFundLoading(false);
    setLoading(false);
  };

  const AddNavValue = async (obj: any) => {
    setUpdateLoading(true);
    try {
      const filteredArr = allDailyNav?.filter((ele) => ele?.checked);
      if (filteredArr?.length === 0) {
        toast.error("Kindly select fund first");
        setUpdateLoading(false);
        return;
      }
      // const response = await addDailyNav(email, allDailyNav);
      const response = await addDailyNav(email, filteredArr);
      if (response.data.status == 200) {
        toast.success(response.data.message);
        setTimeout(() => {
          getDailyNav();
        }, 3000);
      } else if (response?.data?.status == "401") {
        setPreviousNavModal(true);
        setPreviousNavData(response.data.data);
      } else {
        toast.error(response.data.message);
      }
      setUpdateLoading(false);
    } catch (error: any) {
      if (error.response != undefined) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
      setUpdateLoading(false);
    }
  };

  const decimalValue = (value, len) => {
    if (value === 0 || value === parseInt(value, 10)) return value;
    value = value.toString();
    let startingValue = value.split(".")[0];
    let decimalVal = value.split(".")[1];
    let temp = "";
    if (decimalVal !== undefined) {
      let decimalString = decimalVal.toString();
      if (decimalString.length <= len) {
        temp = startingValue + "." + decimalString;
      } else {
        temp = startingValue + "." + decimalString.substr(0, len);
      }
    } else {
      temp = startingValue;
    }
    return temp;
  };

  const getDataForNAVFundWise = async (fund_Code) => {
    try {
      setUpdateLoading(true);
      const response = await getNavDataForCalculation(
        email,
        sessionStorage.getItem("amc_code") || "",
        fund_Code,
        NAVdate,
      );
      if (response.data.status == 200) {
        if (response.data?.status == 200 && response?.data?.data?.nav > 0) {
          setShowModalNav(true);
          setCalculatedLedgersData(response.data);
          setCalculatedNetAsset(
            parseFloat(
              ((totals) =>
                parseFloat(response.data?.openingAssets || 0) +
                totals.totalDebit -
                totals.totalCredit)(
                calculateLedgerTotals(calculatedLedgersData),
              ).toFixed(4),
            ),
          );
        } else {
          setShowModalNav(false);
          setCalculatedLedgersData([]);
          if (response?.data?.data?.nav == 0) {
            toast.error("Previous nav not found!");
          }
        }
        finalData = response.data.navData;
        setFinalData(finalData);
        // } else {
        //   toast.error("Data not found!");
        // }
      } else {
        toast.error(response.data.message);
      }
      setUpdateLoading(false);
    } catch (error: any) {
      setUpdateLoading(false);
      if (error.response != undefined) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    }
    setUpdateLoading(false);
  };

  const onFieldChangeCheckBoxHandle = (items, index) => {
    const updatedFunds = [...allDailyNav];
    if (
      +items?.total_net_asset > 0 ||
      +items?.total_fund_units > 0 ||
      +items?.nav > 0 ||
      +items?.offer_price > 0 ||
      +items?.redemption_price > 0
    ) {
      updatedFunds[index].checked = true;
    } else {
      updatedFunds[index].checked = false;
    }
    setAllDailyNav(updatedFunds);
  };

  const handleDeleteNavClick = (items: any) => {
    setItemToDelete(items);
    setDeleteNavModal(true);
  };

  const confirmDeleteNav = async () => {
    if (!itemToDelete) return;

    setDeleteLoading(true);
    try {
      const response = await getDeleteFundNav(email, amcCode, itemToDelete._id);

      if (response.data.status === 200) {
        const updatedFunds = allDailyNav.map((item) =>
          item._id === itemToDelete._id
            ? {
                ...item,
                nav: 0,
                total_net_asset: 0,
                total_fund_units: 0,
                offer_price: 0,
                redemption_price: 0,
                calculated_nav_data: 0,
              }
            : item,
        );
        setAllDailyNav(updatedFunds);
        toast.success(`NAV Removed for ${itemToDelete.fund} fund`);
        setDeleteNavModal(false);
        setItemToDelete(null);
      } else {
        toast.error(response.data?.message || "Error");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Error");
    }
    setDeleteLoading(false);
  };

  const renderData = () => {
    return (
      Array.isArray(allDailyNav) &&
      allDailyNav.map((items: any, index: any) => {
        items.offer_rate = "sale";
        return (
          <tr key={index}>
            <td className="align-text-top">
              <div>
                <FormGroup check>
                  <Label
                    style={{
                      top: "2px",
                    }}
                    check
                  >
                    <Input
                      type="checkbox"
                      checked={items?.checked}
                      onChange={() => {
                        const updatedFunds = [...allDailyNav];
                        updatedFunds[index].checked = !items.checked;
                        if (updatedFunds[index].checked === false) {
                          updatedFunds[index].total_net_asset = 0;
                          updatedFunds[index].total_fund_units = 0;
                          updatedFunds[index].nav = 0;
                          updatedFunds[index].offer_price = 0;
                          updatedFunds[index].redemption_price = 0;
                        }
                        setAllDailyNav(updatedFunds);
                      }}
                    />
                    <span className="form-check-sign" />
                  </Label>
                </FormGroup>
              </div>
            </td>
            <td className="align-text-top">{items.fund}</td>
            <td className="align-text-top">
              <div className="form-group d-flex flex-column align-items-start">
                <NumberFormat
                  thousandSeparator={true}
                  decimalScale={4}
                  style={{ textAlign: "right" }}
                  className="form-control"
                  value={(Number(items?.total_net_asset) || 0).toFixed(4)}
                  id={`txt-tna-${index}`}
                  // disabled={!items?.checked}
                  onChange={(e) => {
                    items.total_net_asset =
                      e?.target?.value?.replaceAll(",", "") || 0;
                    items.nav =
                      +items.total_fund_units > 0
                        ? (
                            items.total_net_asset /
                            (items.total_fund_units || 0)
                          ).toFixed(4)
                        : 0;
                    onFieldChangeCheckBoxHandle(items, index);
                    setCode(e.target.value?.replaceAll(",", ""));
                  }}
                />
                <small className="w-100 mt-2">
                  {!items.total_net_asset ||
                  items.total_net_asset?.length > 16 ? (
                    <span>&nbsp;</span>
                  ) : (
                    inWords(items.total_net_asset || 0)
                  )}
                </small>
              </div>
            </td>
            <td className="align-text-top">
              <div className="form-group d-flex flex-column align-items-start">
                <NumberFormat
                  thousandSeparator={true}
                  decimalScale={4}
                  style={{ textAlign: "right" }}
                  className="form-control"
                  value={(Number(items?.total_fund_units) || 0).toFixed(4)}
                  id={`txt-tfu-${index}`}
                  // disabled={!items?.checked}
                  onChange={(e) => {
                    items.total_fund_units =
                      e?.target?.value?.replaceAll(",", "") || 0;
                    items.nav =
                      +items.total_fund_units > 0
                        ? (
                            items.total_net_asset / items.total_fund_units
                          ).toFixed(4)
                        : 0;
                    setCode(e.target.value?.replaceAll(",", ""));
                    onFieldChangeCheckBoxHandle(items, index);
                  }}
                />
                <small className="w-100 mt-2">
                  {!items.total_fund_units ||
                  items.total_fund_units?.length > 16 ? (
                    <span>&nbsp;</span>
                  ) : (
                    inWords(items.total_fund_units || 0)
                  )}
                </small>
              </div>
            </td>
            <td className="align-text-top">
              <div className="form-group d-flex flex-column align-items-start">
                <input
                  type="number"
                  className="form-control"
                  step="0.0001"
                  // readOnly
                  value={(Number(items?.nav) || 0).toFixed(4)}
                  // disabled={!items?.checked}
                  onChange={(e) => {
                    var a = decimalValue(e.target.value, 4);
                    items.nav = a;
                    setCode(e.target.value);
                    onFieldChangeCheckBoxHandle(items, index);
                  }}
                />
                <small className="w-100 mt-2">
                  {!items.nav || items.nav?.length > 16 ? (
                    <span>&nbsp;</span>
                  ) : (
                    inWords(items.nav || 0)
                  )}
                </small>
              </div>
            </td>
            <td className="align-text-top">
              <div className="form-group d-flex flex-column align-items-start">
                <NumberFormat
                  thousandSeparator={true}
                  style={{ textAlign: "right" }}
                  decimalScale={4}
                  className="form-control"
                  // disabled={!items?.checked}
                  value={(Number(items?.offer_price) || 0).toFixed(4)}
                  onChange={(e) => {
                    // var a = e.target.value?.replaceAll(",", "");
                    var a = (
                      Number(e.target.value?.replaceAll(",", "")) || 0
                    ).toFixed(4);
                    items.offer_price = a || 0;
                    setCode(e.target.value?.replaceAll(",", ""));
                    onFieldChangeCheckBoxHandle(items, index);
                  }}
                />
                <small className="w-100 mt-2">
                  {!items.offer_price || items.offer_price?.length > 16 ? (
                    <span>&nbsp;</span>
                  ) : (
                    inWords(items.offer_price || 0)
                  )}
                </small>
              </div>
            </td>
            <td className="align-text-top">
              <div className="form-group d-flex flex-column align-items-start">
                <NumberFormat
                  thousandSeparator={true}
                  style={{ textAlign: "right" }}
                  decimalScale={4}
                  className="form-control"
                  // disabled={!items?.checked}
                  value={items.redemption_price || 0}
                  onChange={(e) => {
                    // var a = e.target.value?.replaceAll(",", "");
                    var a = (
                      Number(e.target.value?.replaceAll(",", "")) || 0
                    ).toFixed(4);
                    items.redemption_price = a || 0;
                    setCode(e.target.value?.replaceAll(",", ""));
                    onFieldChangeCheckBoxHandle(items, index);
                  }}
                />
                <small className="w-100 mt-2">
                  {!items.redemption_price ||
                  items.redemption_price?.length > 16 ? (
                    <span>&nbsp;</span>
                  ) : (
                    inWords(items.redemption_price || 0)
                  )}
                </small>
              </div>
            </td>
            <td className="text-center align-text-top">
              <button
                className="btn btn-default btn-sm"
                disabled={Boolean(deleteLoading)}
                onClick={() => {
                  handleDeleteNavClick(items);
                }}
              >
                Remove
              </button>
            </td>
            <td className="text-center align-text-top">
              <button
                className="btn btn-default btn-sm"
                // disabled={Boolean(updateLoading) || !items?.checked}
                disabled={Boolean(updateLoading)}
                onClick={async () => {
                  await getDataForNAVFundWise(items.fund);
                  setCode("start");
                  items.nav = finalData.nav_per_units;
                  items.total_net_asset = finalData.closing_net_assets;
                  items.total_fund_units = finalData.closing_units;
                  items.offer_price = finalData.offer_per_unit;
                  items.redemption_price = finalData.redemption_per_unit;
                  items.calculated_nav_data = JSON.stringify(finalData);
                  setCode("done");
                }}
              >
                {/* Calculate */}
                <i
                  className="fa fa-calculator text-info"
                  aria-hidden="true"
                ></i>
              </button>
            </td>
          </tr>
        );
      })
    );
  };

  return (
    <>
      {/* --------- Modal for View Ledgers Start------------- */}
      <Modal
        className=""
        dialogClassName="modal90w"
        show={showModalNav ? true : false}
        size="lg"
        backdrop={true}
        onHide={() => {
          setShowModalNav(false);
        }}
        centered={true}
      >
        <div className="modal-header mb-3">
          <button
            aria-hidden={true}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setShowModalNav(false);
            }}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
        </div>
        <div className="modal-body pt-2">
          <div className="d-flex justify-content-end">
            Opening Net Assets:{" "}
            <span
              style={{
                fontWeight: "bold",
                marginLeft: "5px",
              }}
            >
              {numberWithCommas(
                parseFloat(calculatedLedgersData?.openingAssets || 0)?.toFixed(
                  4,
                ),
              )}
            </span>
          </div>
          {calculatedLedgersData?.calculatedLedgers?.length > 0 ? (
            <div
              style={{
                maxHeight: "400px",
              }}
              className="table-responsive"
            >
              <table className="table">
                <thead>
                  <tr>
                    <th>Ledger</th>
                    <th className="text-right">Debit Amount</th>
                    <th className="text-right">Credit Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {calculatedLedgersData?.calculatedLedgers?.map(
                    (item: any, index: number) => {
                      return (
                        <tr key={index}>
                          <td>
                            <label>
                              {item.gl_name} <br />
                              {item.gl_code == "" ? (
                                ""
                              ) : (
                                <small className="text-muted">
                                  ({item.gl_code})
                                </small>
                              )}
                            </label>
                          </td>
                          <td className="text-right">
                            {numberWithCommas(
                              parseFloat(item.debit_amount || 0)?.toFixed(4),
                            )}
                          </td>
                          <td className="text-right">
                            {numberWithCommas(
                              parseFloat(item.credit_amount || 0)?.toFixed(4),
                            )}
                          </td>
                        </tr>
                      );
                    },
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="d-flex justify-content-center">
              No Transaction found!
            </div>
          )}
          {calculatedLedgersData ? (
            <div className="d-flex justify-content-end">
              Closing Net Assets:{" "}
              <span
                style={{
                  fontWeight: "bold",
                  marginLeft: "5px",
                }}
              >
                {numberWithCommas(
                  parseFloat(
                    ((totals) =>
                      parseFloat(calculatedLedgersData?.openingAssets || 0) +
                      totals.totalDebit -
                      totals.totalCredit)(
                      calculateLedgerTotals(calculatedLedgersData),
                    ).toFixed(4),
                  )?.toFixed(4),
                )}
              </span>
            </div>
          ) : (
            <div>Calculating...</div>
          )}
        </div>
      </Modal>
      {/* --------- Modal for View Ledgers End------------- */}

      {/* --------- Modal for Previous Nav Data Start------------- */}
      <Modal
        className=""
        dialogClassName="modal90w"
        show={previousNavModal ? true : false}
        size="lg"
        backdrop={true}
        onHide={() => {
          setPreviousNavModal(false);
        }}
        centered={true}
      >
        <div className="modal-header mb-3">
          <div className="flex justify-content-between align-items-center">
            <h1>Previous NAV data for the following funds is missing</h1>
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                setPreviousNavModal(false);
              }}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
          </div>
        </div>
        <div className="modal-body pt-2">
          <div
            style={{
              maxHeight: "400px",
            }}
            className="table-responsive"
          >
            <table className="table">
              <thead>
                <tr>
                  <th>SR</th>
                  <th className="text-left">Fund Code</th>
                </tr>
              </thead>
              <tbody>
                {previousNavData.length > 0
                  ? previousNavData?.map((item: any, index: number) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td className="text-left">{item?.fund}</td>
                        </tr>
                      );
                    })
                  : null}
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
      {/* --------- Modal for Previous Nav Data End------------- */}

      {/* --------- Modal for Delete Nav Start------------- */}
      <Modal
        className=""
        show={deleteNavModal ? true : false}
        size="sm"
        backdrop={true}
        onHide={() => {
          setDeleteNavModal(false);
        }}
        centered={true}
      >
        <div className="modal-header">
          <h5 className="modal-title">Remove NAV</h5>
          <button
            aria-hidden={true}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setDeleteNavModal(false);
            }}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
        </div>

        <div className="px-2 py-4">
          <div className="modal-body">
            <p className={`${theme === "dark" ? "text-white" : ""}`}>
              Are you sure you want to remove the NAV for{" "}
              <strong>{itemToDelete?.fund}</strong> dated{" "}
              <strong>
                {moment(itemToDelete?.nav_date).format("YYYY-MM-DD")}
              </strong>
              ?
            </p>
          </div>
          <div className="modal-footer px-3 py-2">
            <button
              type="button"
              className="btn btn-sm btn-secondary"
              onClick={() => {
                setDeleteNavModal(false);
              }}
              disabled={deleteLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={() => {
                confirmDeleteNav();
              }}
              disabled={deleteLoading}
            >
              {deleteLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm mr-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Removing...
                </>
              ) : (
                "Remove"
              )}
            </button>
          </div>
        </div>
      </Modal>

      {/* --------- Modal for Delete Nav End------------- */}

      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              {/* <Header /> */}
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Change NAV of Funds</h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>NAV Date:</label>
                        <input
                          style={{
                            colorScheme: theme == "light" ? "light" : "dark",
                          }}
                          type="date"
                          className="form-control"
                          value={NAVdate}
                          onChange={(e) => {
                            setNAVDate(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div
                        style={{
                          marginTop: "5px",
                        }}
                      >
                        <button
                          // className="btn btn-primary btn-block"
                          className="btn btn-primary mt-4"
                          disabled={Boolean(Loading)}
                          onClick={() => getDailyNav()}
                        >
                          <i className="fas fa-search mr-1"></i> Load
                        </button>
                      </div>
                    </div>
                  </div>

                  {Loading ? (
                    <div className="d-flex justify-content-center my-5">
                      <i className="fa fa-spinner fa-spin fa-3x"></i>
                    </div>
                  ) : allDailyNav.length > 0 ? (
                    <>
                      <div
                        className="table-responsive"
                        style={{ overflow: "visible" }}
                      >
                        <table className="table" id="myTable">
                          <thead
                            className="btn-primary"
                            style={{
                              position: "sticky",
                              top: 0,
                              zIndex: 1,
                              backgroundColor: "primary",
                            }}
                          >
                            <tr>
                              <th style={{ width: "3%" }}>
                                <FormGroup check>
                                  <Label
                                    style={{
                                      top: "2px",
                                    }}
                                    check
                                  >
                                    <Input
                                      type="checkbox"
                                      checked={allDailyNav?.every(
                                        (ele) => ele?.checked == true,
                                      )}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          let temp = checkedField?.map(
                                            (ele) => {
                                              return {
                                                ...ele,
                                                checked: true,
                                              };
                                            },
                                          );
                                          setAllDailyNav(temp);
                                          setCheckedField(temp);
                                        } else {
                                          let temp = checkedField?.map(
                                            (ele) => {
                                              return {
                                                total_net_asset: 0,
                                                total_fund_units: 0,
                                                nav: 0,
                                                offer_price: 0,
                                                redemption_price: 0,
                                                checked: false,
                                              };
                                            },
                                          );
                                          setAllDailyNav(temp);
                                          setCheckedField(temp);
                                        }
                                      }}
                                    />
                                    <span className="form-check-sign" />
                                  </Label>
                                </FormGroup>
                              </th>
                              <th style={{ width: "10%" }}>Fund</th>
                              <th
                                className="text-center"
                                style={{ width: "15%" }}
                              >
                                Total Net Assets
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "15%" }}
                              >
                                Total Fund Units Issued
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "15%" }}
                              >
                                Daily NAV
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "15%" }}
                              >
                                Offer Price
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "15%" }}
                              >
                                Redemption Price
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "10%" }}
                              >
                                Delete NAV
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "10%" }}
                              >
                                Calculate NAV
                              </th>
                            </tr>
                          </thead>
                          <tbody id="myUL">{renderData()}</tbody>
                        </table>
                      </div>

                      <div className="">
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            let validationNav = allDailyNav?.filter(
                              (ele) => +ele?.checked,
                            );
                            let hasError = validationNav?.every(
                              (ele) => +ele?.nav <= 0,
                            );
                            if (hasError) {
                              const ofFund = validationNav?.find(
                                (ele) => +ele?.nav <= 0,
                              )?.fund;
                              toast.error(
                                `Nav Should not be empty for ${ofFund}`,
                              );
                            } else {
                              AddNavValue(allDailyNav);
                            }
                          }}
                          disabled={
                            Boolean(updateLoading) ||
                            allDailyNav?.filter((ele) => ele?.checked)
                              ?.length === 0
                          }
                        >
                          {updateLoading ? (
                            <>
                              <span
                                className="spinner-border login-txt spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span className="login-txt"> Loading...</span>
                            </>
                          ) : (
                            <span>Update</span>
                          )}
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="table-empty">
                      <BsTable className="icon" />
                      <p className="text-center empty-text">Empty</p>
                    </div>
                  )}
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default NavComponent;
